import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../react-core/Flux/BaseStore";
import { CompanyDispatcher } from "./Variable";
import { CompanySummariesPaginated } from "../../../../../Wrap/Models/Models/Company/CompanySummariesPaginated";
import { CompanyDetail } from "../../../../../Wrap/Models/Models/Company/CompanyDetail";

export interface CompanyStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: CompanySummariesPaginated;
    singleData?: CompanyDetail;
}

export class CompanyStoreStatic extends BaseStore<CompanyStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(CompanyDispatcher, (actionData) => this.onCompanyStoreResponse(actionData));
    }

    public getLastResult(): CompanyStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getSingleData() {
        return this.getState().singleData;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): CompanyStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
            singleData: null,
        };
    }

    private onCompanyStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Update, singleData: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
